import styled from 'styled-components'

export const XcontestWrapper = styled.div`
  margin-top: 2rem;
`

export const TabWrapper = styled.div`
  display: flex;
  width: 280px;
  margin-top: 3rem;
  justify-content: space-between;

  .btn {
    color: #999999;
    /* width: 193px; */
  }

  .btn.active-btn {
    width: 153px;
    height: 35px;
    background: #ffffff;
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
      0px 0.5px 2px rgba(96, 97, 112, 0.16);
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.navyBlue};
  }
`

export const TabBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
  padding-bottom: 5px;
  cursor: pointer;
  transition: all 0.5s ease;
`

export const ContentWrapper = styled.div`
  margin-top: 2rem;

  .content {
    display: none;
  }

  .content.active-content {
    display: block;
  }
`

export const ContentOne = styled.div``
export const ContentTwo = styled(ContentOne)``

export const ContestFlex = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 30px;

  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    justify-items: center;
  }

  .contest_card_link {
    color: black;
  }
  /* @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    justify-content: center;
  } */

  /* @media (max-width: 980px) {
    justify-content: center;
  } */

  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    place-items: center;
  }
`

export const ContestCard = styled.div`
  width: 310px;
  height: 350px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.09);

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 365px;
  }
  /* padding-bottom: 20px; */
`

export const ContestCardHeader = styled.div`
  height: 160px;
  border-radius: 5px 5px 0 0;
`

export const ContestCardBody = styled.div`
  height: auto;
  padding: 0 10px;

  .name_img {
    display: flex;
    justify-content: space-between;
  }

  h3 {
    color: #000000;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 29px;
  }

  p {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.gray};
    margin-top: -10px;
    color: #4f4f4f;
    mix-blend-mode: normal;
  }

  span {
    color: ${({ theme }) => theme.colors.black};
    padding-right: 5px;
    font-weight: 700;
  }

  .link_wrapper {
    display: flex;
    align-items: center;
    img {
      margin-top: 5px;
    }
    /* justify-content: center; */
  }

  .contest_link {
    color: ${({ theme }) => theme.colors.primaryBlue};
    display: flex;
    align-items: center;

    img {
      padding-left: 5px;
    }
  }
`

export const ContestImg = styled.img`
  width: 100%;
  border-radius: 5px 5px 0 0;
  height: 160px;
  object-fit: cover;
  object-position: center;
`
